export default {"src":"/_next/static/media/ChevronDown.7cf160bc.svg","height":24,"width":24};